import { render } from "./ProgramDetailView.vue?vue&type=template&id=f4df230c"
import script from "./ProgramDetailView.vue?vue&type=script&lang=js"
export * from "./ProgramDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__